import { AdAnalyticsFilter, AdAnalyticsPlacementTypes } from '@kaizenplatform/hugot-entity';

import State from '../core/State';

export const startFetchingAdAnalyticsPlacementTypes = () => (state: State): State => ({
  ...state,
  adAnalyticsPlacementTypes: {
    ...state.adAnalyticsPlacementTypes,
    fetching: state.adAnalyticsPlacementTypes.fetching + 1,
  },
});

export const finishFetchingAdAnalyticsPlacementTypes = () => (state: State): State => ({
  ...state,
  adAnalyticsPlacementTypes: {
    ...state.adAnalyticsPlacementTypes,
    fetching: state.adAnalyticsPlacementTypes.fetching - 1,
  },
});

export const setAdAnalyticsPlacementTypes = (adAnalyticsPlacementTypes: AdAnalyticsPlacementTypes) => (
  state: State,
): State => ({
  ...state,
  adAnalyticsPlacementTypes: {
    ...state.adAnalyticsPlacementTypes,
    placementTypes: adAnalyticsPlacementTypes,
  },
});

export const updateSelectedPlacementTypes = ({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => (
  state: State,
): State => ({
  ...state,
  adAnalyticsPlacementTypes: {
    ...state.adAnalyticsPlacementTypes,
    selectedPlacementTypes: {
      platformKey: platformKey,
      mediaKey: mediaKey,
      placementKey: placementKey,
      period: period,
    },
  },
});

export const disposeAdAnalyticsPlacementTypes = () => (state: State): State => ({
  ...state,
  adAnalyticsPlacementTypes: {
    ...state.adAnalyticsPlacementTypes,
  },
});
